module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="js-flashmessage-component"></div>\n<div class="js-uploader-container ';
 if (withGrid) { 
__p+=' blockGrid blockGrid-4 blockGrid-tablet5';
 } 
__p+='">\n</div>\n';
}
return __p;
};
